/**
 * Rutas de inicio cuando la web se abre como PWA instalada (standalone).
 * Alineado con HomePage / WebHeader: cuenta 2 → libro (Dictionary), 0 / 1 → suscripción BasicDictionary.
 */
export function isStandaloneDisplayMode() {
  if (typeof window === "undefined") return false;
  return (
    window.matchMedia("(display-mode: standalone)").matches ||
    window.matchMedia("(display-mode: fullscreen)").matches ||
    window.navigator.standalone === true
  );
}

function normalizedAccount(raw) {
  if (raw == null || raw === "") return null;
  try {
    return String(JSON.parse(raw));
  } catch {
    return String(raw);
  }
}

/**
 * @returns {string | null} ruta absoluta dentro de la app o null si debe mostrarse la home
 *
 * En `App.js`, solo redirigir al devolver una ruta cuando el usuario **entra** en `/` (p. ej.
 * `history.action === 'POP'` al abrir la PWA). Si llega a `/` con `PUSH`/`REPLACE` desde un
 * `<Link>`, debe mostrarse la Home de marketing.
 */
export function getStandaloneDictionaryStartPath() {
  if (!isStandaloneDisplayMode()) return null;
  const jwt = window.localStorage.getItem("jwt");
  if (!jwt) return null;
  const acc = normalizedAccount(window.localStorage.getItem("account"));
  if (acc === null) return null;
  const termId = window.localStorage.getItem("termId") || "0";
  if (acc === "2") return `/dictionary/${termId}`;
  if (acc === "0" || acc === "1") return `/basicDictionary/${termId}`;
  return null;
}
